import { EChannelProvider } from '@/services/solgari-api/enums/channel-provider.enum';

export const clearIdentity = (
  source: EChannelProvider,
  identity: string | undefined,
): string => {
  if (!identity) {
    return '';
  }

  switch (source) {
    case EChannelProvider.WHATSAPP:
      return identity.replace('whatsapp:+', '');
    case EChannelProvider.SMS:
      return identity.replace('+', '');

    default:
      return identity;
  }
};
